import { useCallback } from "react";

export const useFeedBackHandler = ({
  filters,
  setIsLoading,
  fetchMultipleDistributions,
  handleFeedbackFilterChange,
  setDistributionData,
  fetchSemanticRCA,
  fetchFeedbackData,
  setLoading,
  setErrors,
  setFeedbackData,
  setFeedbackStats,
  fetchFeedbackStats,
  setComplaintsCount,
}) => {
  console.log("filters in feedback handler", filters)
  const handleFeedbackClick = useCallback(
    async (event, series, config) => {
      setIsLoading(true);
      try {
        if (!config || !config.categoryData) {
          console.warn("No category data in config");
          return;
        }

        const clickedData = config.categoryData;
        const clickedValue =
          clickedData.attribute_value || config.selectedCategory;
        const currentAttribute = filters.attribute || "Sector";

        let nextAttributes = [];
        let baseFilters = {
          startDate: filters.startDate,
          endDate: filters.endDate,
          Sector: "All",
          CompanyName: "All",
          Category: "All",
          skip: filters.skip || 0,
          limit: filters.limit || 1000,
        };

        let query = "";

        if (currentAttribute === "Sector") {
          query = clickedValue;
          handleFeedbackFilterChange("Sector", clickedValue);
          handleFeedbackFilterChange("attribute", "CompanyName");
          nextAttributes = ["CompanyName"];
          baseFilters.Sector = clickedValue;
        }

        else if (currentAttribute === "CompanyName") {
          if (filters.CompanyName && filters.CompanyName !== 'All') {
            setIsLoading(false);
            return;
          }

          query = clickedValue;
          handleFeedbackFilterChange("CompanyName", clickedValue);
          handleFeedbackFilterChange("attribute", "CompanyName"); // stay at CompanyName
          nextAttributes = ["CompanyName"];
          baseFilters.Sector = filters.Sector || "All";
          baseFilters.CompanyName = clickedValue;
        }

        else if (currentAttribute === "Category") {
          handleFeedbackFilterChange("Category", clickedValue);
          handleFeedbackFilterChange("attribute", "Category");
          nextAttributes = [];
          baseFilters.Sector = filters.Sector || "All";
          baseFilters.CompanyName = filters.CompanyName || "All";
          baseFilters.Category = clickedValue;
        }

        if (nextAttributes.length > 0) {
          await fetchMultipleDistributions(
            nextAttributes,
            baseFilters,
            setDistributionData,
            setLoading,
            setErrors
          );
        }

        const statsFilters = {
          ...filters,
          startDate: baseFilters.startDate,
          endDate: baseFilters.endDate,
          Sector: baseFilters.Sector,
          CompanyName: baseFilters.CompanyName,
          Category: baseFilters.Category,
        };

        const statsData = await fetchFeedbackStats(statsFilters, setFeedbackStats);
        setComplaintsCount(statsData?.total_feedback_count || statsData?.total_count || 0);

      } catch (error) {
        console.error("Error handling feedback click:", error);
      } finally {
        setIsLoading(false);
      }
    },
    [
      filters,
      setIsLoading,
      fetchMultipleDistributions,
      handleFeedbackFilterChange,
      setDistributionData,
      fetchSemanticRCA,
      setLoading,
      setErrors,
      fetchFeedbackData,
      setFeedbackData,
      setFeedbackStats,
      fetchFeedbackStats,
      setComplaintsCount,
    ]
  );

  return { handleFeedbackClick };
};
